import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/@mui+material-nextjs@5.18.0_@emotion+cache@11.14.0_@mui+material@5.18.0_@emotion+react@_009805e32ae763840d8cc1eba1e1bab4/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.23_react@18.3.1__@emotion_19a5ee0476da228d66b5ad5c143bb0c3/node_modules/@mui/material/styles/index.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/@next+third-parties@14.2.31_next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@p_136adb713b217b3227633e59a1e04604/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/@next+third-parties@14.2.31_next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@p_136adb713b217b3227633e59a1e04604/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/@next+third-parties@14.2.31_next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@p_136adb713b217b3227633e59a1e04604/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/jotai@2.13.0_@babel+core@7.28.0_@babel+template@7.27.2_@types+react@18.3.23_react@18.3.1/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-_5bff9c3197e981f02092deb89f915fe1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["InitializeGPT"] */ "/home/runner/work/tud-website/tud-website/src/components/Ads/GPT.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationEvents"] */ "/home/runner/work/tud-website/tud-website/src/components/NavigationEvents/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Notification"] */ "/home/runner/work/tud-website/tud-website/src/components/Notifications/Notification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/Notifications/Toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/ThemeRegistry/theme.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/providers/ads.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertsProvider"] */ "/home/runner/work/tud-website/tud-website/src/providers/alerts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/providers/options.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopupsProvider"] */ "/home/runner/work/tud-website/tud-website/src/providers/popups.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/home/runner/work/tud-website/tud-website/src/providers/posthog.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_normalize.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_ads.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_header.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_navBar.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_homepage.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_topStories.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_trending.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_cta.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_contact.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_news.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_category.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_breadcrumb.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_btt.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_notifications.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_footer.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_article.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_event.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_search.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_inputs.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_account.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_userAuth.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_article-cards.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_enquiry.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_author.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_notFound.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_faq.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_popup.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_slideshow.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_subscription.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_filter.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_updateCard.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_ondemand.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_recommendedContent.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/theme/_globalicons.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/utils/_grid.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/utils/_accordion.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/utils/_spinner.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/utils/_headings.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/utils/_accessibility.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_variable.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_break-xl.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_break-lg.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_break-md.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_break-sm.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_break-xs.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/scss/responsive/_media-print.scss");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextProvider"] */ "/home/runner/work/tud-website/tud-website/src/utils/supabase/useUser.tsx");
